"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveFromCartCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class RemoveFromCartCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackRemoveFromCartEvent(this.input);
    }
}
exports.RemoveFromCartCommand = RemoveFromCartCommand;
